import type { MantineThemeOverride } from '@mantine/core'

export const breakpoints: MantineThemeOverride['breakpoints'] = {
  xs: '36em',
  sm: '48em',
  md: '62em',
  lg: '75em',
  xl: '93em',
}

export const fontSizes: MantineThemeOverride['fontSizes'] = {
  '2xs': '0.625rem', // ---- 10px
}

export const spacing: MantineThemeOverride['spacing'] = {
  '3xs': '0.0625rem', // --- 1px
  '2xs': '0.125rem', // ---- 2px
  xs: '0.25rem', // -------- 4px
  sm: '0.5rem', // --------- 8px
  md: '0.75rem', // -------- 12px
  lg: '1rem', // ----------- 16px
  xl: '1.5rem', // --------- 24px
  '2xl': '2rem', // -------- 32px
  '3xl': '2.5rem', // ------ 40px
}

export const radius: MantineThemeOverride['radius'] = {
  '3xs': '0.0625rem', // --- 1px
  '2xs': '0.125rem', // ---- 2px
  xs: '0.25rem', // -------- 4px
  sm: '0.375rem', // ------- 6px
  md: '0.5rem', // --------- 8px
  lg: '0.75rem', // -------- 12px
  xl: '1rem', // ----------- 16px
  '2xl': '1.25rem', // ----- 20px
  '3xl': '1.5rem', // ------ 24px
}
